'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var JobTag = function JobTag(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("path", {
    d: "M23.295,11.466L12.522,0.694C12.091,0.263,11.493,0,10.834,0H2.457C1.14,0,0.062,1.077,0.062,2.394v8.378\n\tc0,0.658,0.264,1.256,0.706,1.699l10.772,10.772c0.431,0.431,1.03,0.694,1.687,0.694c0.659,0,1.257-0.264,1.688-0.705l8.379-8.379\n\tC23.735,14.422,24,13.824,24,13.166S23.724,11.897,23.295,11.466z M17.049,15.861l-1.379,1.431c-0.24,0.25-0.601,0.25-0.84,0\n\tl-5.461-5.663c-1.38,0.56-3,0.249-4.14-0.934c-1.2-1.245-1.5-3.112-0.78-4.605l2.64,2.676l1.8-1.867l-2.58-2.676\n\tc1.44-0.685,3.24-0.436,4.44,0.809c1.14,1.182,1.44,2.862,0.899,4.294l5.461,5.664C17.35,15.177,17.35,15.612,17.049,15.861z"
  }));
};

var JobTag$1 = iconStyles()(JobTag);

module.exports = JobTag$1;
